export default "__VITE_ASSET__H04TL1AC__"